import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { combineReducers } from 'redux'
import journey from './reducers/journey-reducers'
import journeyState from './reducers/journeyState-reducers'
import util from './reducers/util-reducers'

// non-react dispatchers
import { windowResize, timerTick, resetInactivityTimer, toggleIdleWarning } from './actions/util-actions'
import { setKioskMode, resetToHome } from './actions/journey-actions'
import moment from 'moment'

import {
   fetchSingle,
   workerRequestTask,
   registerWorker,
   workerClaimTask
} from './actions/worker-actions'

const initialState = {}

const enhancers = []
const middleware = [
  thunk,
]

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const rootReducer = combineReducers({
  journey,
  journeyState,
  util,
})

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

// debugger: making store available in dev tools
if (process.env.NODE_ENV === 'development') {
  window.store = store;
}

// set up a few default hooks
const eventHook = () => {
  store.dispatch(windowResize(window.innerHeight, window.innerWidth))
}
window.addEventListener('resize', eventHook);
window.addEventListener('load', eventHook);

/*
   Asset Prefetch Workers
 */
const worker = (workerId) => {
   const state = store.getState()
   const fetchQueue = state.journey.getIn(['fetchQueue'])
   const myStatus = fetchQueue.get('workerStatus').get(workerId)
   // register worker if there is no registration record
   if (myStatus === undefined) {
      console.log(`registering worker with id ${workerId}`)
      store.dispatch(registerWorker(workerId)) 
      setTimeout(() => worker(workerId), 500) 
      return
   }

   if (myStatus.get('status') === 'idle') {
      // workerRequestTask will not do anything if
      // the queue has nothing in it
      // console.log(`worker ${workerId} requesting task`)
      store.dispatch(workerRequestTask(workerId))
   }

   if (myStatus.get('status') === 'waiting') {
      // task has been assigned but we havent processed it yet
      // console.log(`worker ${workerId} executing task`)
      const url = myStatus.get('task')
      store.dispatch(workerClaimTask(workerId))
      store.dispatch(fetchSingle(url, workerId))
   }

   // if there's more to be done, come back quickly.
   const interval = (fetchQueue.get('queue').size > 0) ? 200 : 5000
   setTimeout(() => worker(workerId), interval)
}

/* Set up the workers for prefetching images */
/* NOTE: Too many workers (even if idle) can cause performance
   issues with css transtions -- tweak as needed */
// only use default worker setup in kiosk mode
if (window.location.search.indexOf('kiosk_mode') >= 0) {
   // set global 'kiosk' mode flag
   store.dispatch(setKioskMode(true))

   setTimeout(() => worker(0), 500)
   setTimeout(() => worker(1), 600)
   setTimeout(() => worker(2), 700)
   setTimeout(() => worker(3), 800)
}


window.addEventListener('load', () => {
  let bottomNode = document.querySelector('.journey-container-bottom');
  let topNode = document.querySelector('.journey-container-top');

  // Inactivity Timer Reset on click/tap events
  if (bottomNode)
    bottomNode.addEventListener("click", () => {store.dispatch(resetInactivityTimer('bottom'))}, true);
  if (topNode)
    topNode.addEventListener("click", () => {store.dispatch(resetInactivityTimer('top'))}, true);
});

const checkInactivity = (galleryId) => {
  const state = store.getState()

  const navState = state.journeyState.getIn([galleryId, 'currentNavStep'])  
  const duration = moment.duration(moment.now() - state.journeyState.getIn([galleryId, 'inactive', 'lastClick']))
  const idleWarning = state.journeyState.getIn([galleryId, 'inactive', 'showIdleWarning'])

  if (navState !== 0) {
    if (duration.asMinutes() > 1 && !idleWarning) {
      store.dispatch(toggleIdleWarning(galleryId, true))
    }
    if (duration.asMinutes() > 2) {
      store.dispatch(toggleIdleWarning(galleryId, false))
      store.dispatch(resetToHome(galleryId))
    }
  }
}

setInterval(() => {
  // dispatch the tick event
  store.dispatch(timerTick())

  checkInactivity('top')
  checkInactivity('bottom')

  const state = store.getState()
  // after some time, reload the whole app to get any new software updates
  const restClickDuration = moment.duration(moment.now() - state.journey.get('lastGlobalClick'))
  if (restClickDuration.asMinutes() > 60) {
    window.location.reload(true)
  }

  if (restClickDuration.asMinutes() > 10) {
    // take an opportunity to reload the API? Or just let it be with the global reset
  }

}, 5000)

export default store


// WEBPACK FOOTER //
// ./src/store.js